import { render, staticRenderFns } from "./IntroductionToSourdough.vue?vue&type=template&id=59aadfa8&scoped=true"
import script from "./IntroductionToSourdough.vue?vue&type=script&lang=js"
export * from "./IntroductionToSourdough.vue?vue&type=script&lang=js"
import style0 from "./IntroductionToSourdough.vue?vue&type=style&index=0&id=59aadfa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aadfa8",
  null
  
)

export default component.exports